<template>
    <b-container>
        <b-card v-if="carrierId===null">
            <h4>Create a new carrier.</h4>
            <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'carrier-list'}">Back to Carriers</b-breadcrumb-item>
            <b-breadcrumb-item active>New Carrier</b-breadcrumb-item>
            </b-breadcrumb>

        </b-card>
        <b-card v-if="carrierId!==null">
            <b-breadcrumb>
                <b-breadcrumb-item :to="{name: 'carrier-list'}">Back to Carriers</b-breadcrumb-item>
                <b-breadcrumb-item active>Modify {{ carrier.carrier_name }}</b-breadcrumb-item>
            </b-breadcrumb>
            <h1>Carrier: {{ carrier.carrier_name }}</h1>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="Carrier Name"
                    label-for="input-1"
                    description="The name of the carrier"
                    >
                    <b-form-input
                        id="input-1"
                        v-model="carrier.carrier_name"
                        type="text"
                        placeholder="Enter Carrier Name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="Segment Fee"
                    label-for="input-2"
                    description="The segment cost for the carrier"
                    >
                    <b-form-select v-model="carrier.fee" :options="carrierFees"></b-form-select>

                </b-form-group>

                <b-form-checkbox
                    v-model="carrier.needs_review"
                    class="mb-3 mt-3"
                    name="check-button"
                    switch>
                    Carrier needs review of cost
                </b-form-checkbox>
                <b-row>
                    <b-col>
                <b-button type="submit" variant="primary" v-if="carrierId!==null">Update</b-button>
                <b-button type="submit" variant="primary" v-if="carrierId===null">Create</b-button>
                    </b-col>
                    <b-col>
                        <b-button class="float-right" variant="danger" v-if="carrierId!==null" v-on:click="deleteCarrier">Delete  <font-awesome-icon icon="trash" /></b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-card>

    </b-container>
</template>
<script>
import { CarrierApi } from "@/app/carriers/carrierApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";

export default {
    name: "CarrierDetail",
    props: {
        carrierId: {
            type: String,
            required: false
        }
    },
    mixins: [userMixin],
    data () {
        return {
            carrier: {
                carrier_id: null,
                carrier_name: null,
                fee: null,
                needs_review: false
            },
            carrierFees: []
        }
    },
    async mounted() {
        if (this.carrierId)
            this.carrier = await this.getCarrier();
        this.carrierFees = this.$store.state.frontEndSettings.carrier_fees;

    },
    methods: {
        async getCarrier() {
            try {
                const { data } = await CarrierApi.getCarrierDetail(this.carrierId);
                return data
            } catch(e) {
                handleError(e, "Error trying to fetch Carrier Information");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            try {
                if(this.carrierId!==null) {
                    this.carrier.carrier_id = this.carrierId;
                    this.carrier.needs_review = false;
                    const { data } = await CarrierApi.updateCarrierDetail(this.carrierId, this.carrier);
                    this.$toast.success('Updated carrier successfully');
                    await this.$router.push({ name: 'carrier-list'});
                } else {
                    // we dont need to set review since we are creating here it's already reviewed
                    this.carrier.needs_review = false;
                    const { data } = await CarrierApi.createCarrier(this.carrier);
                    this.carrier = data;
                    this.$toast.success('Created carrier successfully');
                    this.$router.push({ name: 'carrier-list'});
                }
            } catch (e) {
                handleError(e, "Error trying to process Carrier Request");
            }
        },
        async deleteCarrier() {
            try {
                const { data } = await CarrierApi.deleteCarrier(this.carrierId);
                this.$toast.success('Successfully removed carrier ');
                this.$router.push({ name: 'carrier-list'});
            } catch (e) {
                handleError(e, "Error trying to process Carrier Request");
            }
        }

    }
}
</script>
